import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarData } from "./SidebarData.jsx";
import { IconContext } from "react-icons/lib";
import SubMenu from "./SubMenu.jsx";
import { useUserAuth } from "../context/UserAuthContextProvider";

const Nav = styled.div`
  background: black;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const SidebarNav = styled.nav`
  background: black;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 10;
  @media only screen and (max-width: 480px) {
      display: ${({ sidebar }) => (sidebar === true ? "none" : !sidebar ? "flex" : "flex")};
  }
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const Sidebar = () => {
  const { logOut } = useUserAuth();
  const handleLogOut = async () => {
    try {
      await logOut();
    } catch (err) {
      console.log(err);
    }
  };

  const [sidebar, setSidebar] = useState(true);
  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav>
          <NavIcon to="#">
            <FaIcons.FaBars onClick={showSidebar} />
          </NavIcon>
          <h1
            style={{
              textAlign: "center",
              marginLeft: sidebar ? "210px" : "20px",
              overflowY: "hidden",
              color: "white",
              fontSize: 25,
              fontVariantCaps: "small-caps"
            }}
          >
            {sidebar ? null : "Khidmat Foundation"}
          </h1>
          <button
            style={{
              float: "right",
              marginLeft: sidebar ? "155vh" : "148vh",
            }}
            type="submit"
            className="btn btn-danger mhide"
            onClick={handleLogOut}
          >
            Logout =<i class="fa fa-sign-out"> </i>
          </button>
        </Nav>
        <SidebarNav className="scroll " sidebar={sidebar}>
          <SidebarWrap>
            <NavIcon to="#">
              <AiIcons.AiOutlineClose onClick={showSidebar} />
              <span className="pName">Khidmat Founadtion</span>
            </NavIcon>
            {SidebarData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </>
  );
};

export default Sidebar;
